import React from "react";
import RadioButton from "../../../base/components/RadioButton";

const TEST_TYPES = [
  {
    id: "yellow",
    label: "Yellow Tube Test",
    description: "For serum-based biomarkers including hormones, vitamins, minerals, lipids, liver function, and thyroid markers."
  },
  {
    id: "purple",
    label: "Purple Tube Test",
    description: "For EDTA plasma biomarkers including Haemoglobin A1c (HbA1c) for blood sugar balance assessment."
  },
  {
    id: "both",
    label: "Both Tubes Test",
    description: "Comprehensive retest including biomarkers from both yellow (serum including hormones, vitamins, minerals, lipids) and purple (HbA1c) tubes for complete coverage."
  }
];

export default function StepSelectTestTube({ selectedType, setSelectedType }) {
  return (
    <div>
      {TEST_TYPES.map((type) => (
        <div
          key={type.id}
          className={`border rounded mb-3 p-3 d-flex align-items-start cursor-pointer ${selectedType === type.id ? "border-primary bg-light" : ""}`}
          onClick={() => setSelectedType(type.id)}
          style={{ borderWidth: selectedType === type.id ? 2 : 1 }}
        >
          <RadioButton
            checked={selectedType === type.id}
            onChange={() => setSelectedType(type.id)}
            name="testType"
            label={
              <>
                <div className="fw-bold">{type.label}</div>
                <div className="text-muted">{type.description}</div>
              </>
            }
            containerClassName="me-3 mt-1"
          />
        </div>
      ))}
    </div>
  );
}
